<template>
  <div class="settings">
    <div class="settings__status">
      <UtilityStatusBar :status="appStatus" />
    </div>

    <div class="settings__close">
      <UtilityIconButton
        v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
        content="Close"
        size="lg"
        variant="round"
        backgroundColor="#12130f"
        highlightColor="rgba(255,255,255,0.7)"
        highlightBackgroundColor="#070806"
        @click.native="close()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
      </UtilityIconButton>
    </div>

    <div class="settings__left">
      <div class="settings__leftWrap">
        <div class="user">
          <div class="user__initials">
            {{ userInitials }}
          </div>

          <div class="user__details">
            <div class="user__name">{{ userName }}</div>
            <div class="user__registered">{{ userRegistered }}</div>
          </div>
        </div>

        <div class="nav">
          <div
            v-for="item in views"
            :key="item.name"
            :class="['nav__item', currentView === item.url ? 'nav__item--selected' : '', item.disabled === true ? 'nav__item--disabled' : '']"
            @click="item.disabled === false ? view(item.url) : false"
          >
            <div
              class="nav__icon"
              v-html="item.icon"
            />

            <div
              class="nav__text"
              v-html="item.name"
            />
          </div>

          <div
            class="nav__item"
            @click="logout()"
          >
            <div class="nav__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M8 9v-4l8 7-8 7v-4h-8v-6h8zm6-7c-1.787 0-3.46.474-4.911 1.295l.228.2 1.395 1.221c1.004-.456 2.115-.716 3.288-.716 4.411 0 8 3.589 8 8s-3.589 8-8 8c-1.173 0-2.284-.26-3.288-.715l-1.395 1.221-.228.2c1.451.82 3.124 1.294 4.911 1.294 5.522 0 10-4.477 10-10s-4.478-10-10-10z" /></svg>
            </div>

            <div class="nav__text">
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="settings__right">
      <div class="settings__header">
        <h1>{{ pageTitle }}</h1>
      </div>

      <div class="settings__content">
        <SettingsDetails v-if="currentView === 'details'" />
        <!--<SettingsPersonalization v-else-if="currentView === 'personalization'" />
        <SettingsLicenses v-else-if="currentView === 'licenses'" />-->
        <SettingsNotifications v-else-if="currentView === 'notifications'" />
        <SettingsLogs v-else-if="currentView === 'logs'" />
      </div>
    </div>
  </div>
</template>

<script>
import SettingsDetails from '@/views/settings/Details.vue'
import SettingsPersonalization from '@/views/settings/Personalization.vue'
import SettingsLicenses from '@/views/settings/Licenses.vue'
import SettingsNotifications from '@/views/settings/Notifications.vue'
import SettingsLogs from '@/views/settings/Logs.vue'
import UtilityStatusBar from '@/components/utility/StatusBar.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'

export default {
  components: {
    SettingsDetails,
    SettingsPersonalization,
    SettingsLicenses,
    SettingsNotifications,
    SettingsLogs,
    UtilityStatusBar,
    UtilityIconButton
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      currentView: 'details',
      views: [{
        'name': 'User details',
        'url': 'details',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M20.822 18.096c-3.439-.794-6.64-1.49-5.09-4.418 4.72-8.912 1.251-13.678-3.732-13.678-5.082 0-8.464 4.949-3.732 13.678 1.597 2.945-1.725 3.641-5.09 4.418-3.073.71-3.188 2.236-3.178 4.904l.004 1h23.99l.004-.969c.012-2.688-.092-4.222-3.176-4.935z"/></svg>',
        'disabled': false
      }, {
        'name': 'Personalization',
        'url': 'personalization',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M17 12.645v-2.289c-1.17-.417-1.907-.533-2.28-1.431-.373-.9.07-1.512.6-2.625l-1.618-1.619c-1.105.525-1.723.974-2.626.6-.9-.374-1.017-1.117-1.431-2.281h-2.29c-.412 1.158-.53 1.907-1.431 2.28h-.001c-.9.374-1.51-.07-2.625-.6l-1.617 1.619c.527 1.11.973 1.724.6 2.625-.375.901-1.123 1.019-2.281 1.431v2.289c1.155.412 1.907.531 2.28 1.431.376.908-.081 1.534-.6 2.625l1.618 1.619c1.107-.525 1.724-.974 2.625-.6h.001c.9.373 1.018 1.118 1.431 2.28h2.289c.412-1.158.53-1.905 1.437-2.282h.001c.894-.372 1.501.071 2.619.602l1.618-1.619c-.525-1.107-.974-1.723-.601-2.625.374-.899 1.126-1.019 2.282-1.43zm-8.5 1.689c-1.564 0-2.833-1.269-2.833-2.834s1.269-2.834 2.833-2.834 2.833 1.269 2.833 2.834-1.269 2.834-2.833 2.834zm15.5 4.205v-1.077c-.55-.196-.897-.251-1.073-.673-.176-.424.033-.711.282-1.236l-.762-.762c-.52.248-.811.458-1.235.283-.424-.175-.479-.525-.674-1.073h-1.076c-.194.545-.25.897-.674 1.073-.424.176-.711-.033-1.235-.283l-.762.762c.248.523.458.812.282 1.236-.176.424-.528.479-1.073.673v1.077c.544.193.897.25 1.073.673.177.427-.038.722-.282 1.236l.762.762c.521-.248.812-.458 1.235-.283.424.175.479.526.674 1.073h1.076c.194-.545.25-.897.676-1.074h.001c.421-.175.706.034 1.232.284l.762-.762c-.247-.521-.458-.812-.282-1.235s.529-.481 1.073-.674zm-4 .794c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333z"/></svg>',
        'disabled': true
      }, {
        'name': 'Licenses',
        'url': 'licenses',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 0c-3.371 2.866-5.484 3-9 3v11.535c0 4.603 3.203 5.804 9 9.465 5.797-3.661 9-4.862 9-9.465v-11.535c-3.516 0-5.629-.134-9-3zm-.548 15l-3.452-3.362 1.237-1.239 2.215 2.123 4.382-4.475 1.238 1.238-5.62 5.715z"/></svg>',
        'disabled': true
      }, {
        'name': 'Notifications',
        'url': 'notifications',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M15.137 3.945c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.667 2.712-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.195-10.594-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm3 20c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6z"/></svg>',
        'disabled': false
      }, {
        'name': 'Bookmarks',
        'url': 'bookmarks',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M11 5c-1.629 0-2.305-1.058-4-3h-7v20h24v-17h-13zm3.599 12l-2.599-1.39-2.599 1.39.518-2.902-2.125-2.042 2.921-.404 1.285-2.652 1.285 2.652 2.921.404-2.125 2.042.518 2.902z"/></svg>',
        'disabled': true
      }, {
        'name': 'Activity log',
        'url': 'logs',
        'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M1.8 9l-.8-4h22l-.8 4h-2.029l.39-2h-17.122l.414 2h-2.053zm18.575-6l.604-2h-17.979l.688 2h16.687zm3.625 8l-2 13h-20l-2-13h24zm-8 4c0-.552-.447-1-1-1h-6c-.553 0-1 .448-1 1s.447 1 1 1h6c.553 0 1-.448 1-1z"/></svg>',
        'disabled': false
      }]
    }
  },
  computed: {
    appStatus () {
      return this.$store.getters['app/getAppStatus']
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    userInitials () {
      return this.$store.getters['user/getInitials']
    },
    userName () {
      return this.$store.getters['user/getName']
    },
    userRegistered () {
      let data = this.$store.getters['user/getData']

      if (data && data.created_at) {
        let time = data.created_at.split(/[- :]/)
        let date = new Date(Date.UTC(time[0], time[1] - 1, time[2], time[3], time[4], time[5]))
        let result = date.getUTCFullYear() + '/' + ('0' + (date.getUTCMonth() + 1)).slice(-2) + '/' + ('0' + date.getUTCDate()).slice(-2)

        return result
      }

      return '??'
    },
    pageTitle () {
      return this.$route.name
    }
  },
  mounted () {
    let url = this.$route.path.split('/')

    if (Array.isArray(url)) {
      let checkUrl = url.pop()

      this.views.forEach(view => {
        if (checkUrl === view.url) {
          this.currentView = checkUrl
        }
      })
    }
  },
  methods: {
    close () {
      this.$router.push('/') // TODO: Should go "back"?
    },
    view (url) {
      this.currentView = url
      this.$router.push('/settings/' + url)
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  min-height: 100vh;
  background-color: $bg-4;
  background-image: url('/img/pattern_navy.png');
  background-position: 0 0;
  background-repeat: repeat;

  @media screen and (min-width: $breakpointSm) {
    flex-direction: row;
  }

  h1, h2 {
    @include font('header--sm', $black, 0.6);
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-weight: 500;
  }

  &__status {
    position: absolute;
    z-index: 102;
    width: 100%;
    height: 3px;
    background-color: rgba($bg-1, 0);
    transition: background-color 0.2s ease-in-out;
  }

  &__left {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $bg-5;
    overflow: hidden;

    @media screen and (min-width: $breakpointSm) {
      width: 180px;
    }

    @media screen and (min-width: $breakpointMd) {
      width: 240px;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 280px;
    }

    &Wrap {
      position: relative;
      width: 100%;

      @media screen and (min-width: $breakpointSm) {
        position: fixed;
        width: 180px;
      }

      @media screen and (min-width: $breakpointMd) {
        width: 240px;
      }

      @media screen and (min-width: $breakpointLg) {
        width: 280px;
      }
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__header {
    width: 100%;
    height: 52px;
    background-color: rgba($black, 0.25);
    border-bottom: 1px solid $black;

    @media screen and (min-width: $breakpointLg) {
      height: 54px;
    }

    h1, h2 {
      @include font('header--md', $white, 0.9);
      width: 90%;
      margin: 0 auto;
      line-height: 52px;

      @media screen and (min-width: $breakpointLg) {
        line-height: 54px;
      }
    }
  }

  &__content {
    width: 100%;
    border-top: 1px solid rgba($white, 0.1);
  }

  &__close {
    position: fixed;
    top: 8px;
    right: 16px;
    z-index: 99;
  }
}

.user {
  @include font('content--sm', $black, 0.6);
  display: flex;
  align-items: center;
  width: calc(100% - 2rem);
  height: 48px;
  padding: 16px;
  font-weight: 500;
  border-bottom: 1px solid rgba($black, 0.3);

  @media screen and (min-width: $breakpointLg) {
    @include font('content--md', $black, 0.7);
    font-weight: 500;
    padding: 16px;
  }

  &__initials {
    width: 36px;
    min-width: 36px;
    height: 36px;
    line-height: 36px;
    background-color: $bg-4;
    padding: 0px;
    margin-right: 1rem;
    text-align: center;
    border-radius: 999px;
    color: $bg-5;
    font-size: 16px;
  }

  &__name {
    color: rgba($black, 0.8);
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.nav {
  @include font('content--sm', $black, 0.7);
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: auto;
  height: auto;
  font-weight: 500;
  background-color: $bg-5;
  padding: 1rem 0 0 0;
  border-top: 1px solid $white;

  @media screen and (min-width: $breakpointSm) {
    width: calc(100% - 1rem);
    min-height: calc(100vh - 82px - 1rem);
    padding: 1rem 0 0 1rem;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--md', $black, 0.7);
    font-weight: 500;
    padding: 1rem 0 0 1rem;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-items: center;
    border-radius: 0;
    padding: 0.75rem;
    margin: 0.25rem 0;

    @media screen and (min-width: $breakpointSm) {
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      margin-top: auto;
    }

    &:hover:not(.nav__item--selected) {
      background-color: rgba($bg-4, 0.2);
      cursor: pointer;
    }

    &--selected {
      background-color: $blue;
    }

    &--disabled {
      color: rgba($black, 0.4);
      cursor: not-allowed !important;

      /deep/ svg {
        fill: rgba($black, 0.4);
      }
    }
  }

  &__icon {
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    margin-right: 12px;
    fill: $bg-4;
    display: block;

    @media screen and (min-width: $breakpointSm) {
      display: none;
    }

    @media screen and (min-width: $breakpointMd) {
      display: block;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 22px;
      min-width: 22px;
      height: 22px;
      min-height: 22px;
    }
  }
}

</style>
